<!-- Adaptateur : l'API publique reste `[startDate]` / `[endDate]` (deux FormControl)
     pour que les 3 consommateurs n'aient rien à changer.

     Configuration VOLONTAIREMENT MINIMALE : le composant du kit expose beaucoup
     d'options (4 modes de sélection, un rail de 7 raccourcis, granularité à la
     minute, 2 mois côte à côte). BackStage n'a besoin que d'une plage de dates.
     - `[modes]` à une seule entrée masque le sélecteur de mode ;
     - `[presets]` vide retire le rail de raccourcis ;
     - `[months]="1"` réduit le calendrier à un seul mois.

     Variante `chip` et non `button` : c'est la seule qui porte la croix
     d'effacement sur le déclencheur (`clearable`). Elle remet la sélection à
     `clearsTo` — `all` par défaut, donc les deux contrôles vidés. Le `label` n'est
     lu que par cette variante ; « Dates » reprend le libellé de repos qu'affichait
     le bouton. -->
<app-date-range-picker
  label="Dates"
  variant="chip"
  clearable
  [fullWidth]="true"
  [months]="1"
  [modes]="['range']"
  [presets]="[]"
  granularity="day"
  [value]="selection()"
  (rangeChange)="appliquerSelection($event)"
/>
